<template>
  <!-- 来訪者情報設定画面 -->
  <v-dialog v-model="dialog" persistent max-width="800px">
    <v-container>
      <v-card>
        <v-card-title class="InsertTitle">
          <v-toolbar class="headline" color="primary" dark>{{
            this.title
          }}</v-toolbar>
        </v-card-title>
        <v-card-text class="cardTextStyle">
          <v-form ref="p1DialogForm" v-model="valid" lazy-validation>
            <v-row>
              <v-col cols="12"> </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <ryou-input
                  label="来訪者名"
                  v-model="model.visit_name"
                  :value="model.visit_name"
                  :maxlength="7"
                  :rules="requiredRules"
                >
                </ryou-input>
              </v-col>
              <v-col cols="4">
                <ryou-date-format
                  v-model="model.sh_input_day"
                  :value="model.sh_input_day"
                  :type="'date'"
                  :format="'$1/$2/$3'"
                  :label="'来訪日'"
                  :rules="requiredRules"
                >
                </ryou-date-format>
                <!--  
                                    <RyoTime v-model="model.input_time" :value="model.input_time" :type="'time'"
                                             :label="'時間'" :rules="requiredRules">
                                    </RyoTime>
        -->
              </v-col>
              <v-col cols="4">
                <ryou-input
                  label="車両番号"
                  v-model="model.vehicle_no"
                  :value="model.vehicle_no"
                  :maxlength="10"
                >
                </ryou-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="4">
                <RyouSelect
                  :label="'訪問先建物'"
                  :items="buildOptionItems"
                  :itemText="'building_name'"
                  :itemValue="'building_id'"
                  v-model="buildSelectValue"
                  :value="buildSelectValue"
                >
                </RyouSelect>
              </v-col>
              <v-col cols="noBotPadding">
                <RyouAutocomplete
                  class="ryouSelectPCStyle2"
                  :label="'訪問先'"
                  :items="reserveUserOptionItems"
                  :itemText="'user_name'"
                  :itemValue="'user_id'"
                  v-model="reserveUserSelectValue"
                  :value="reserveUserSelectValue"
                >
                </RyouAutocomplete>
              </v-col>
              <v-col cols="4" class="headerTitle">
                <ryou-input
                  label="備考"
                  v-model="model.visit_remark"
                  :value="model.visit_remark"
                  :maxlength="100"
                >
                </ryou-input>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <ryou-input
                  label="用件"
                  v-model="model.visit_requirement"
                  :value="model.visit_requirement"
                  :maxlength="20"
                  :rules="requiredRules"
                >
                </ryou-input>
              </v-col>
            </v-row>
          </v-form>
        </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'閉じる'"
            :handlerClick="handleCancel"
            :iconCls="'mdi-close'"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
          <ryou-black-btn
            :label="'登録'"
            :handlerClick="handleOkConfirm"
          ></ryou-black-btn>
          <v-spacer></v-spacer>
        </v-card-actions>
      </v-card>
    </v-container>
    <ryou-confirm ref="confirm"></ryou-confirm>
  </v-dialog>
</template>

<script>
import RyouSelect from "@/components/formInput/RyouSelect";
import RyouAutocomplete from "@/components/formInput/RyouAutocomplete";
import RyouInput from "@/components/formInput/RyouInput.vue";
import RyouBlackBtn from "@/components/formInput/RyouBlackBtn.vue";
import RyouDateFormat from "@/components/formInput/RyouDateFormat.vue";
//  import RyouTime from "@/components/formInput/RyouTime.vue";
import RyouConfirm from "@/components/dialog/RyouConfirm.vue";

export default {
  name: "VisitorDialog",
  components: {
    RyouSelect,
    RyouAutocomplete,
    RyouBlackBtn,
    RyouConfirm,
    RyouInput,
    RyouDateFormat,
    //        RyouTime,
  },
  mounted() {
    this.requiredRules.push(this.GlobalRules.required);
    this.inputRulesTwo.push(this.GlobalRules.required);
    this.inputRulesTwo.push(this.GlobalRules.counter_2);
    this.inputRulesTwo.push(this.GlobalRules.numbercuurency);
  },
  props: {
    url: {
      type: Object,
      required: true,
      default: () => {},
    },
  },
  data: () => ({
    dialog: false,
    valid: true,
    title: "",
    visitorUpdateFlg: false,
    requiredRules: [],
    inputRulesTwo: [],
    inputRulesFive: [],
    buildSelectValue: "",
    buildOptionItems: [],
    reserveUserSelectValue: "",
    reserveUserOptionItems: [],
    model: {
      building_id: "",
      visit_seq_no: "",
      visit_name: "",
      input_date: "",
      sh_input_day: "",
      sh_input_time: "",
      visit_requirement: "",
      visit_remark: "",
      vehicle_no: "",
      user_id: "",
      card_no: "",
      appapproval_status: "",
    },
  }),
  created() {
    this.initData();
    if (this.loadFlag == true) {
      this.selectedData();
    }
  },
  methods: {
    add() {
      this.open();
      this.visitorUpdateFlg = false;
      this.title = "来訪者情報登録";
    },
    edit(record) {
      this.open();
      this.title = "来訪者情報更新";
      this.visitorUpdateFlg = true;
      setTimeout(() => {
        this.model = Object.assign({}, record);
      }, 10);
      // console.log(this.model);
      // console.log(this.model.input_date);
      this.visit_name = this.model.visit_name;
      this.visit_seq_no = this.model.visit_seq_no;
      this.input_date = this.model.input_date;
      this.sh_input_day = this.model.sh_input_day;
      this.sh_input_time = this.model.sh_input_time;
      this.visit_requirement = this.model.visit_requirement;
      this.visit_remark = this.model.visit_remark;
      this.vehicle_no = this.model.vehicle_no;
      this.user_id = this.model.user_id;
      this.card_no = this.model.card_no;
      this.appapproval_status = this.model.appapproval_status;
    },
    initData() {
      //物件名リスト取得
      let params = {
        userId: this.$store.getters.getUserId,
        userClass: this.$store.getters.getUserClass,
      };
      this.getRequest(
        "/dormitoryUserRevise/buildListGet",
        params,
        this.$store.getters.getUserToken
      ).then((data) => {
        if (data.success) {
          if (data.result != null) {
            this.buildOptionItems = data.result; //物件名
          } else {
            this.buildOptionItems = [];
          }
        }
      });
    },
    handleOkConfirm() {
      var valid = this.$refs.p1DialogForm.validate();
      if (valid) {
        var that = this;
        if (this.visitorUpdateFlg) {
          this.$refs.confirm
            .open("更新", "来訪者情報を更新します。宜しいですか？", {
              color: "info",
            })
            .then((confirm) => {
              if (confirm) {
                let params = {
                  user_id: this.$store.getters.getUserId,
                  building_id: this.model.building_id,
                  visit_name: this.model.visit_name,
                  visit_seq_no: this.model.visit_seq_no,
                  input_date: this.setDate(
                    this.model.sh_input_day,
                    this.model.sh_input_time
                  ),
                  visit_requirement: this.model.visit_requirement,
                  visit_remark: this.model.visit_remark,
                  vehicle_no: this.model.vehicle_no,
                  card_no: this.model.card_no,
                  appapproval_status: this.model.appapproval_status,
                };
                // console.log(this.url.update);
                // console.log(params);
                this.putRequest(
                  this.url.update,
                  params,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    that.$emit("ok");
                    that.close();
                  }
                });
              }
            });
        } else {
          this.$refs.confirm
            .open("登録", "来訪者情報を登録します。宜しいですか？", {
              color: "info",
            })
            .then((confirm) => {
              if (confirm) {
                let insertParams = {
                  user_id: this.$store.getters.getUserId,
                  building_id: this.model.building_id,
                  visit_name: this.model.visit_name,
                  input_date: this.setDate(
                    this.model.sh_input_day,
                    this.model.sh_input_time
                  ),
                  visit_requirement: this.model.visit_requirement,
                  visit_remark: this.model.visit_remark,
                  vehicle_no: this.model.vehicle_no,
                  card_no: this.model.card_no,
                  appapproval_status: this.model.appapproval_status,
                };
                this.postRequest(
                  this.url.add,
                  insertParams,
                  this.$store.getters.getUserToken
                ).then((resp) => {
                  if (resp.success) {
                    that.$emit("ok");
                    that.close();
                  }
                });
              }
            });
        }
      }
    },
    handleCancel() {
      this.close();
    },
    close() {
      this.dialog = false;
      this.visit_name = "";
      this.visit_seq_no = "";
      this.input_date = "";
      this.sh_input_day = "";
      this.sh_input_time = "";
      this.visit_requirement = "";
      this.visit_remark = "";
      this.vehicle_no = "";
      this.user_id = "";
      this.card_no = "";
      this.appapproval_status = "";
    },
    open() {
      this.dialog = true;
      if (this.$refs.p1DialogForm) {
        this.$refs.p1DialogForm.reset();
        this.$refs.p1DialogForm.resetValidation();
      }
    },
    setDate(value1, value2) {
      let in_date = value1 + " " + value2;
      return in_date;
    },
  },
};
</script>

<style scoped>
.InsertTitle {
  padding: 0px 0px 25px !important;
}

.radioTitle {
  padding-top: 0px;
}
</style>
